(function ($) {
  console.log("🚀");

  lucide.createIcons();

  // Lightbox
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    closeButton: "top",
  });

  const swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next-unique",
      prevEl: ".swiper-button-prev-unique",
    },
  });

  $(".menu-toggle").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("is-active");
    $(".nav-and-social").toggleClass("is-active");

    if ($(".nav-and-social").hasClass("is-active")) {
      $("#menu ul li").each(function (index) {
        $(this).css({
          "transition-delay": index * 0.1 + "s",
        });
      });

      // Set transition delay for social links
      var menuItemsCount = $("#menu ul li").length;
      $(".social-links").css({
        "transition-delay": menuItemsCount * 0.1 + 0.2 + "s",
      });
    } else {
      $("#menu ul li, .social-links").css("transition-delay", "");
    }
  });

  // Close menu when clicking outside
  $(document).on("click touchstart", (event) => {
    var $menu = $(".nav-and-social");
    var $toggle = $(".menu-toggle");

    if (
      !$menu.is(event.target) &&
      $menu.has(event.target).length === 0 &&
      !$toggle.is(event.target) &&
      $toggle.has(event.target).length === 0
    ) {
      $menu.removeClass("is-active");
      $toggle.removeClass("is-active");
      $("#menu ul li, .social-links").css("transition-delay", "");
    }
  });

  // Prevent clicks inside the menu from closing it
  $(".nav-and-social").on("click touchstart", (e) => {
    e.stopPropagation();
  });

  // Handle window resize
  $(window).resize(() => {
    if ($(window).width() > 960) {
      $(".nav-and-social").addClass("is-active").css({
        opacity: "",
        visibility: "",
        transform: "",
      });
      $(".menu-toggle").removeClass("is-active");
      $("#menu ul li, .social-links").css("transition-delay", "");
    } else {
      if (!$(".menu-toggle").hasClass("is-active")) {
        $(".nav-and-social").removeClass("is-active");
      }
    }
  });

  var header = $("header");
  var scrollThreshold = 10; // Number of pixels to scroll before showing blur

  $(window).scroll(function () {
    if ($(this).scrollTop() > scrollThreshold) {
      header.addClass("scrolled");
    } else {
      header.removeClass("scrolled");
    }
  });

  // Trigger the scroll event on page load
  // This ensures the correct state if the page is refreshed while scrolled
  $(window).trigger("scroll");

  // Open nav shop link in new window
  $("li.shop-link a").attr("target", "_blank");

  console.log("🧑‍🚀");
})(jQuery);
